import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { LOGO_URL, NAV_LINKS } from "@/lib/constants";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-ivory/85 backdrop-blur-md border-b border-warmGray/20" : "bg-transparent"
      }`}
    >
      <div className="container-editorial flex items-center justify-between py-5">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3 group">
          <img src={LOGO_URL} alt="Sarah Atkinson Advisory" className="h-16 lg:h-[68px] w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-9" data-testid="navbar-links">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-ui uppercase tracking-[0.16em] text-[12px] font-medium transition-colors hover:text-sage ${
                  isActive ? "text-navy" : "text-charcoal/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="navbar-cta-work-with-me"
          className="hidden lg:inline-flex items-center gap-2 bg-sage text-ivory font-ui uppercase tracking-[0.18em] text-[12px] px-7 py-3.5 rounded-full hover:bg-navy transition-all duration-300"
        >
          Work With Me <ArrowRight className="w-3.5 h-3.5" />
        </Link>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-navy"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-ivory border-t border-warmGray/20" data-testid="mobile-menu">
          <div className="container-editorial py-6 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-ui uppercase tracking-[0.18em] text-xs text-charcoal hover:text-sage"
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-cta-work-with-me"
              className="btn-sage justify-center"
            >
              Work With Me <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
